(() => {
  const headingSelectors = [
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    '[role="heading"]',
  ];

  window.swinger.observer.initialize('dialog:not([aria-labelledby]),[role="dialog"]:not([aria-labelledby])', (elem) => {
    const uuid = Date.now();
    const id = `swinger-dialog-label-${uuid}`;
    let labelElem = elem.querySelector(headingSelectors.join(','));

    if (!labelElem) {
      labelElem = window.swinger.$('*', elem).find((elem) => !elem.childElementCount && elem.textContent.trim());
    }

    if (!labelElem) {
      return;
    }

    document.querySelectorAll(`#${id}`).forEach((elem) => {
      elem.removeAttribute('id');
    });
    labelElem.setAttribute('id', id);
    elem.setAttribute('aria-labelledby', id);
  }, false);
})();
